import { useTranslation } from "next-i18next";
import Tags from "../ui/Tags";

type Props = {
  tag: string;
  url: string;
  style?: "default" | "gray";
};

const Tag = ({ tag, url, style }: Props) => {
  const { t } = useTranslation();

  return (
    <Tags.Tag key={tag} tag={t(tag, { ns: "tags" })} url={url} style={style} />
  );
};

export default Tag;
